module.exports = __webpack_public_path__ + "img/129.504472d.png";